export enum ApiEndPoints {
    runFlowBuilder = 'analytics-builder/work-flow-builder/run',
    flowBuilderPreviewApi = 'analytics-builder/work-flow-builder/preview-list',
    FlowBuilderPublishApi = 'analytics-builder/work-flow-builder/publish'
}
